import {
  ownershipQueueRequiresRawTable,
  type IncidentOpsQueueFilter,
} from '../../domain/incidents/incidentOwnershipQueueFilter';

export type IncidentTableMode = 'grouped' | 'raw';

/** Product default for Investigate when `table_mode` is absent. */
export const DEFAULT_INCIDENT_TABLE_MODE: IncidentTableMode = 'grouped';

export function parseIncidentTableModeParam(raw: string | null | undefined): IncidentTableMode | '' {
  const value = String(raw || '').trim();
  return value === 'raw' || value === 'grouped' ? value : '';
}

export function readIncidentTableModeParam(searchParams: URLSearchParams): IncidentTableMode | '' {
  return parseIncidentTableModeParam(searchParams.get('table_mode') || searchParams.get('tableMode'));
}

function heatmapHourImpliesRaw(searchParams: URLSearchParams): boolean {
  const heatmapHourRaw = (searchParams.get('heatmap_hour') || '').trim();
  if (!/^(?:[0-9]|1[0-9]|2[0-3])$/.test(heatmapHourRaw)) return false;
  return String(searchParams.get('review') || '').trim() !== '1';
}

function opsQueueImpliesRaw(searchParams: URLSearchParams): boolean {
  const opsQueueRaw = (searchParams.get('ops_queue') || searchParams.get('opsQueue') || '').trim();
  return ownershipQueueRequiresRawTable(opsQueueRaw as IncidentOpsQueueFilter);
}

/** Default used only when the URL has no explicit `table_mode`. */
export function impliedIncidentTableMode(searchParams: URLSearchParams): IncidentTableMode {
  if (opsQueueImpliesRaw(searchParams) || heatmapHourImpliesRaw(searchParams)) return 'raw';
  return DEFAULT_INCIDENT_TABLE_MODE;
}

/** Single source of truth: explicit URL param, else implied default. */
export function resolveIncidentTableMode(searchParams: URLSearchParams): IncidentTableMode {
  return readIncidentTableModeParam(searchParams) || impliedIncidentTableMode(searchParams);
}
